import { Box, Typography } from '@mui/material';
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';

import { FORTA_GRAY2 } from '../../../../../utils/colors';
import {
  ACTIVITY_STAGE_ARC_INNER_RADIUS,
  ACTIVITY_STAGE_ARC_OUTER_RADIUS,
  ACTIVITY_STAGE_SEGMENTS,
} from '../constants';
import { ACTIVITY_STAGE_ARC_SX, ACTIVITY_STAGE_METER_SX } from '../styles';

import type { ActivityStageMeterProps } from '../types';

function ActivityStageMeter({ stage, color, label }: ActivityStageMeterProps) {
  return (
    <Box sx={ACTIVITY_STAGE_METER_SX}>
      <Box sx={ACTIVITY_STAGE_ARC_SX}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={ACTIVITY_STAGE_SEGMENTS}
              dataKey="value"
              startAngle={180}
              endAngle={0}
              innerRadius={ACTIVITY_STAGE_ARC_INNER_RADIUS}
              outerRadius={ACTIVITY_STAGE_ARC_OUTER_RADIUS}
              cornerRadius={3}
              paddingAngle={4}
              fill={FORTA_GRAY2}
              isAnimationActive={false}
            >
              {ACTIVITY_STAGE_SEGMENTS.map((segment, index) => (
                <Cell key={segment.name} fill={index < stage ? color : FORTA_GRAY2} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </Box>
      <Typography fontSize={13} fontWeight={600} color={color}>
        {label}
      </Typography>
    </Box>
  );
}

export default ActivityStageMeter;
